<template>
    <el-dialog
        title="战队成员"
        :visible.sync="dialogVisible"
        v-if="dialogVisible"
        width="1190px"
        :destroy-on-close="true"
        >
        <div class="member-list-view">
            <div class="code-box"><span>战队码</span>{{ code }}</div>
            <div class="member-list">
                <div class="list-item leader">
                    <div class="player-item" v-for="(item,index_1) in leader_list" :key="index_1">
                        <div class="avatar" :class="{'check-in':!item.state}"><div class="label" v-if="item.state">队长</div></div>
                        <p class="play-name">{{ item.nick }}</p>
                    </div>
                </div>
                <div class="list-item player">
                    <div class="player-item" v-for="(item,index_2) in member_list" :key="index_2">
                        <div class="avatar" :class="{'check-in':!item.state}"><div class="label" v-if="item.state">队员</div></div>
                        <p class="play-name">{{ item.nick }}</p>
                    </div>                  
                </div>
                <div class="list-item backup">
                    <div class="player-item" v-for="(item,index_3) in backup_list" :key="index_3">
                        <div class="avatar" :class="{'check-in':!item.state}"><div class="label" v-if="item.state">替补</div></div>
                        <p class="play-name">{{ item.nick }}</p>
                    </div>
                    <div class="back-up-ctrl">
                        <div class="player-item" v-for="n in (2-backup_list.length)" :key="n" @click="addMember"><div class="add u-btn"></div><p class="play-name">添加替补</p></div>
                    </div>                    
                </div>
            </div>                     
        </div>
    </el-dialog>    
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        code : '2887',
        member_data : [],
        leader_list : [],
        member_list : [],
        backup_list : [],
        tid : '',
        zid : '',
      };
    },
    created (){
        this.leader_list = this.member_data.filter(function(e){
            return e.pos == 1;
        });
        this.member_list = this.member_data.filter(function(e){
            return e.pos >=2 && e.pos <= 10;
        });
        this.backup_list = this.member_data.filter(function(e){
            return e.pos >10;
        });
    },
    methods: {
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      addMember() {
          this.dialogVisible = false;
          this.$add_modal({
              zid : this.zid,
              tid : this.tid,
          });
      },
    }
  };
</script>

<style scoped>

    .member-list-view{
        position: relative;
    }

    .code-box{
        position: absolute;
        top: 0;
        right: 20px;
        width: 125px;
        height: 30px;
        line-height: 30px;
        color: #0e0c0b;
        font-size: 14px;
        text-align: center;
        background-color: #f9e9ae;;
    }

    .code-box span{
        color: #820000;
        padding-right: 20px;
    }

.list-item{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
}

.player-item{
    margin: 0 20px 40px;
}

.member-list .avatar{
    position: relative;
    width: 124px;
    height: 124px;
    margin: 0 auto 10px;
    background-image: url(../../assets/images/bg-avatar.png);
}

.member-list .avatar .label{
    position: absolute;
    bottom: 8px;
    left: 0;
    width: 100%;
    text-align: center;
    color: #fff;
}

.member-list .avatar.check-in{
    background-image: url(../../assets/images/check-in.png);
}

/* .icon-check{
    display: inline-block;
    width: 19px;
    height: 16px;
    margin-right: 10px;
    background-image: url(../images/icon-ok.png);
    vertical-align: middle;
} */

.play-name{
    font-size: 20px;
    color: #333333;
    text-align: center;
}

.play-name em{
    display: inline-block;
    width: 6em;
    overflow:hidden;
    text-overflow:ellipsis;
    vertical-align: middle;
    white-space: nowrap;   
}

.back-up-ctrl{
    display: flex;
    justify-content: center;
    align-items: baseline;
}

.u-btn.add{
    width: 124px;
    height: 124px;
    margin-bottom: 10px;
    background-image: url(../../assets/images/btn-add.png);    
}    
</style>


// WEBPACK FOOTER //
// src/components/memberModal/MemberModal.vue